

<template>
 <div>
  <input type="text" v-model="query" v-on:keyup="autoassigned" class="form-control" name="assigned" 
    @focus="modal = true" required size="255">
  <div class="panel-footer" v-if="results.length > 0 && modal">
   <ul class="list-group">
    <li class="list-group-item" @click="setState(result.assigned)" v-for="result in results">
     {{ result.assigned }}
    </li>
   </ul>
  </div>
 </div>
</template>
<script>
 export default{
  props: ['query'],
  data(){
   return {
    modal: false,
    results: []
   }
  },
  methods: {
   autoassigned(){
    this.results = [];
    if(this.query.length > 2){
     axios.get('/api/searchassigned',{params: {query: this.query}}).then(response => {
      this.results = response.data;
     });
    }
   },
   setState(state){
    this.query = state;
    this.modal = false;
   }
  }
 }
</script>